/**
 * workbench-gateway.js
 * Submits workbench tool executions via fetch/FormData.
 */

import { resolveFetch, submitFormRequest } from './form-submit.js';

function inferApiBase() {
  if (typeof window === 'undefined') {
    return 'http://localhost:3001';
  }
  const host = window.location?.hostname || 'localhost';
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  return isLocal ? `http://${host}:3001` : 'https://api.agilepro.ai';
}

function normaliseAttachments(list = []) {
  if (!Array.isArray(list)) {
    return list ? [list] : [];
  }
  return list.filter((file) => file != null);
}

export class WorkbenchGateway {
  constructor({ fetch, apiBase } = {}) {
    const fetchImpl = resolveFetch(fetch);
    if (!fetchImpl) {
      throw new Error('WorkbenchGateway requires a fetch implementation');
    }
    this.fetch = fetchImpl;
    this.apiBase = apiBase || inferApiBase();
  }

  /**
   * A follow-up on a tool's output (spec 028).
   *
   * The same form-encoded shape as a run, because the endpoint behind it takes
   * files too and the one thing worse than two request shapes is two request
   * shapes that are nearly the same.
   */
  async submitFollowup({ tool, teamId, teamName, threadId, message, attachments = [] }) {
    return submitFormRequest({
      fetch: this.fetch,
      url: `${this.apiBase}/api/workbench/followup`,
      fields: {
        teamId,
        team: teamName || '',
        tool,
        threadId: threadId || '',
        message: message || '',
      },
      files: normaliseAttachments(attachments),
    });
  }

  async submit({ tool, teamId, teamName, payload = {}, attachments = [] }) {
    return submitFormRequest({
      fetch: this.fetch,
      url: `${this.apiBase}/api/workbench`,
      fields: {
        teamId,
        team: teamName || '',
        tool,
        payload: JSON.stringify(payload ?? {}),
      },
      files: normaliseAttachments(attachments),
    });
  }
}

if (typeof window !== 'undefined') {
  window.AgileProGateways = window.AgileProGateways || {};
  window.AgileProGateways.WorkbenchGateway = WorkbenchGateway;
}
